"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tryWithDelay = tryWithDelay;
function tryWithDelay({ attemptNumber, captureException, delay, errorMessage, functionToCall, hasSucceeded, maxAttempts, }) {
    // If the last run succeeded bail
    if (hasSucceeded)
        return;
    // If we've tried the max number of times log error and bail
    if (attemptNumber > maxAttempts) {
        captureException(new Error(errorMessage));
        return;
    }
    // Else try after the delay
    setTimeout(() => {
        const didSucceed = functionToCall();
        tryWithDelay({
            attemptNumber: attemptNumber + 1,
            captureException,
            delay,
            errorMessage,
            functionToCall,
            hasSucceeded: didSucceed,
            maxAttempts,
        });
    }, delay);
}
